<template>
<v-col>
    <v-row class="no-gutters align-center">
        <v-col class="pr-2 pr-md-0">
            <v-card class="transaction" flat dense>
                <v-row no-gutters>
                    <div class="flex-shrink-1">
                        <v-card :class="status" min-width="10" height="100%" flat tile></v-card>
                    </div>
                    <v-col>
                        <v-row no-gutters class="align-stretch" :class="status">
                            <v-col class="flex-grow-0 pa-4 d-flex flex-column text-center" style="min-width: 375px;">
                                <div class="flex-grow-1 mb-0 mb-md-4">
                                    <v-row no-gutters class="align-baseline justify-center">
                                        <v-chip :class="status" class="">
                                            <v-col class="text-right status pa-0">{{ statusText }}</v-col>
                                        </v-chip>
                                        <p v-if="item.order_id" class="caption overline blue-grey--text text--darken-2 pt-4 pl-4 mb-0">{{ item.order_id }}</p>
                                        <p v-else class="caption overline blue-grey--text text--darken-2 pt-4 pl-4 mb-0">{{ item.id }}</p>
                                    </v-row>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="item-dates">
                                    <template v-if="item.posted_at">
                                        <div class="blue-grey--text text--darken-2">
                                            <p class="overline blue-grey--text lighten-4 mb-0">Posted</p>
                                            <p class="body-2 font-weight-medium mb-0">{{ item.posted_at | moment('l') }} {{ item.posted_at | moment('LT') }}</p>
                                        </div>
                                    </template>
                                    <template v-if="item.accepted_at">
                                        <div class="blue-grey--text text--darken-2">
                                            <p class="overline blue-grey--text lighten-4 mb-0">Accepted</p>
                                            <p class="body-2 font-weight-medium mb-0">{{ item.accepted_at | moment('l') }} {{ item.accepted_at | moment('LT') }}</p>
                                        </div>
                                    </template>
                                    <template v-if="item.confirmed_at">
                                        <div class="blue-grey--text text--darken-2">
                                            <p class="overline blue-grey--text lighten-4 mb-0">Confirmed</p>
                                            <p class="body-2 font-weight-medium mb-0">{{ item.confirmed_at | moment('l') }} {{ item.confirmed_at | moment('LT') }}</p>
                                        </div>
                                    </template>
                                    <template v-if="item.matcher_payment_completed_at">
                                        <div class="blue-grey--text text--darken-2">
                                            <p class="overline blue-grey--text lighten-4 mb-0">Payment Completed</p>
                                            <p class="body-2 font-weight-medium mb-0">{{ item.matcher_payment_completed_at | moment('l') }} {{ item.matcher_payment_completed_at | moment('LT') }}</p>
                                        </div>
                                    </template>
                                    <template v-if="item.cancelled_at">
                                        <div class="blue-grey--text text--darken-2">
                                            <p class="overline blue-grey--text lighten-4 mb-0">Cancelled</p>
                                            <p class="body-2 font-weight-medium mb-0">{{ item.cancelled_at | moment('l') }} {{ item.cancelled_at | moment('LT') }}</p>
                                        </div>
                                    </template>
                                </div>
                            </v-col>

                            <v-divider :vertical="$vuetify.breakpoint.lgAndUp" light class="flex-shrink-1" width="1px" color="#f5f5f5"></v-divider>

                            <v-col class="d-flex align-center justify-center mx-n1 pa-5 col-12" lg="7" md="4">
                                <v-row class="align-center justify-center flex-row no-wrap px-8 py-4 no-gutters">
                                    <v-col>
                                        <v-row class="align-end">
                                            <v-col class="flex-shrink-1 d-flex flex-column align-center justify-left">
                                                <div class="text-center text-lg-left">
                                                    <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">
                                                      {{ item.user.firstname }} sent</p>
                                                    <p class="headline subtitle-1 font-weight-medium mb-0">
                                                        {{ formatAmount(posterAmount)}}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ item.poster_currency }}</span>
                                                    </p>
                                                </div>
                                            </v-col>
                                            <v-col class="align-center justify-center flex-grow-1 col-12" lg="4">
                                                <v-row class="d-flex flex-row flex-nowrap">

                                                    <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                                <v-avatar class="primary--outline" size="38" v-on="on">

                                                                    <!-- SENDING BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                    <v-icon color="primary" size="18">mdi-bank-outline</v-icon>

                                                                </v-avatar>
                                                            </template>
                                                            <span>Payment bank account</span>
                                                        </v-tooltip>
                                                    </v-col>

                                                    <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                        <v-icon color="blue-grey lighten-4" size="10">mdi-chevron-double-right</v-icon>
                                                        <v-sheet color="blue-grey lighten-4" width="100%" height="2px"></v-sheet>
                                                    </v-col>

                                                    <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">

                                                        <!-- DURATION NEEDS FUNCTIONALITY -->
                                                        <v-chip outlined>0-1 days</v-chip>

                                                    </v-col>

                                                    <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                        <v-sheet color="blue-grey lighten-4" width="100%" height="2px"></v-sheet>
                                                        <v-icon color="blue-grey lighten-4" size="10">mdi-chevron-double-right</v-icon>
                                                    </v-col>

                                                    <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                                <v-avatar class="primary--outline" size="38" v-on="on">

                                                                    <!-- RECIPIENT BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                    <v-icon color="primary" size="18">mdi-bank-outline</v-icon>

                                                                </v-avatar>
                                                            </template>
                                                            <span>Recipient bank account</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col class="flex-shrink-1 text-right d-flex flex-column align-center justify-right">
                                                <div class="text-center text-lg-right">
                                                    <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">You Received</p>
                                                    <p class="headline subtitle-1 font-weight-medium mb-0">
                                                        {{ formatAmount(amount) }}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ item.matcher_currency}}</span>
                                                    </p>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row class="align-end">
                                            <v-col class="flex-shrink-1 text-center d-flex flex-column align-center justify-center">
                                                <div>
                                                    <p class="overline blue-grey--text lighten-4 mb-0">Exchange rate ({{ item.poster_currency }}/{{ item.matcher_currency }})</p>
                                                    <p class="body-1 font-weight-medium mb-0"> {{ parseFloat(strongerExchangeRate(item)).toFixed(2) }}</p>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col class="d-flex justify-center align-center flex-column pa-2">
                                <template v-if="item.company && item.company.logo">
                                    <v-img width="150" contain :src="item.company.logo"></v-img>
                                </template>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</v-col>
</template>

<script>
export default {
    props: {
        item: Object,
    },
    computed: {
        status() {
            if (this.item.is_cancelled) {
                return 'cancelled';
            } else if (this.item.is_removed) {
                return 'expired';
            } else if (this.item.matcher_payment_completed_at !== null) {
                return 'deposited';
            } else {
                return 'processing';
            }
        },
        statusText() {
            if (this.status === 'deposited') {
                return  'Money in Bank';
            } else if (this.status === 'processing') {
                return 'Money is on its Way';
            } else {
                return this.status;
            }
        },
        amount() {
          const { match } = this.item;
          let fee = 0;
          let amount = this.item.matcher_amount;

          if (match) {
            fee = match.matcher_fee || 0;
            amount = match.matcher_amount;
          }

          amount = parseFloat(amount) + parseFloat(fee);
          return amount;
        },
        posterAmount() {
            const { match } = this.item;

            if (match) {
                return match.poster_amount;
            }

            return this.item.poster_amount;
        },
    },
    methods: {
        strongerExchangeRate(order) {
            if (order.exchange_rate < 1) {
                if (order.exchange_rate === 0){
                    return 0;
                }
                return 1 / order.exchange_rate;
            }
            return order.exchange_rate;
        },
    },
};
</script>


<style scoped>
a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
}

.statusBar {
    position: absolute;
    top: 0;
    width: 100%;
    color: #cfd8dc;
}

/* Processing & Unpaid */
.v-card.processing, .v-card.unpaid {
    background-color: #dde !important;
    border-color: #dde !important;
    color: #000000aa !important;
}

.v-chip.processing, .v-chip.unpaid {
    background: #dde !important;
    color: #000000aa !important;
}

/* Payment Received */
.v-card.deposited {
    background-color: #0cd6c0 !important;
    border-color: #0cd6c0 !important;
    color: #000000aa !important;
}

.v-chip.deposited {
    background: #0cd6c0 !important;
    color: #000000aa !important;
}

/* Cancelled */
.v-card.cancelled {
    background-color: #FF8A80 !important;
    border-color: #FF8A80 !important;
    color: #bbb !important;
}

.v-chip.cancelled {
    background: #FF8A80 !important;
    color: #000000aa !important;
}

.cancelled i.v-icon.notranslate.mdi.mdi-bank-outline.theme--light.primary--text,  .cancelled p, .cancelled span {
    color: #bbb !important;
    caret-color: #bbb !important;
}

.cancelled .primary--outline {
    border: 2px solid #bbb;
}

.theme--light.v-divider {
    border-color: rgba(0,0,0,0.02);
}

.transaction {
    overflow: hidden;
}

.primary--outline {
    background-color: transparent;
    border: 2px solid #181235;
}

.item-dates > div {
    margin-bottom: 16px;
}

.item-dates :last-child {
    margin-bottom: unset;
}
</style>
